<div class="card mb-5 chart-wrapper">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column align-items-center">
      <h4 style="margin: 0;">{{ data.title | capitalCase }}</h4>
    </div>
  </div>
  <div class="card-body chart-body" [style.height]="resolvedHeight">
    <div [id]="data.widgetId" class="chart-host" [hidden]="hasError"></div>
    <app-data-error *ngIf="hasError" [message]="errorMessage"></app-data-error>
  </div>
</div>
